/*
 * @Descripttion: 德运通天然气管理系统
 * @version: 1.0.0
 * @Author: xst
 * @Date: 2020-03-31 13:00:48
 * @LastEditors: xst
 * @LastEditTime: 2020-07-06 19:28:28
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
import Vue from "./btnPermission";
import ElementUI from "element-ui";

import "element-ui/lib/theme-chalk/index.css";
// import "./assets/iconfont/iconfont.css";
import "font-awesome/css/font-awesome.css";
import "./assets/icon/iconfont.css";
import "./assets/css/common.scss";
/*import "default-passive-events";*/

import App from "./App.vue";
import router from "./router";
import store from "./vuex";
import i18n from "./i18n/i18n";
import api from "./ajax/api.js";
import qs from "qs";
import Print from "vue-print-nb";
import filters from "./publicMethods/filters";
import { message } from "./publicMethods/resetMessage.js";
import { count } from "./publicMethods/count.js";
import "./publicMethods/NumberFormat.js";
import '../src/components/gpy/jquery-1.4.4.min'
import '../src/components/gpy/gpyhs'
import axios from "./publicMethods/axios.js";
import Util from "./utils/util"
import dateSelect from "../src/components/DateAndTime/dateSelect.vue"
import dateSelectT from "../src/components/DateAndTime/dateSelectT.vue"
import timeSelect from "../src/components/DateAndTime/timeSelect.vue"
import timeSelectB from "../src/components/DateAndTime/timeSelectB.vue"
import dateTimeSelect from "../src/components/DateAndTime/dateTimeSelect.vue"
import dateTimeSelectT from "../src/components/DateAndTime/dateTimeSelectT.vue"
import moreFilter from "../src/components/more-filter.vue"
import autoHeight from './utils/directive/auto-height.js';
Vue.directive('auto-height',autoHeight)
Vue.component('moreFilter',moreFilter)
Vue.component('DateSelect',dateSelect)
Vue.component('DateSelectTimestamp',dateSelectT)
Vue.component('TimeSelect',timeSelect)
Vue.component('TimeSelectB',timeSelectB)
Vue.component('DateTimeSelect',dateTimeSelect)
Vue.component('DateTimeSelectTimestamp',dateTimeSelectT)
import {indexAndPage} from "./publicMethods/mixins";
Vue.mixin(indexAndPage);
// 地图
import BaiduMap from "vue-baidu-map";

import htmlToPdf from "@/utils/htmlToPDF.js";
Vue.use(htmlToPdf);

Vue.use(BaiduMap, {
  ak: "qIWGShzpblGXuYubMOPOWMh2LuLxSpLn"
});

// 日期控件周
import Moment from 'moment'
Vue.prototype.moment = Moment
// 打印
Vue.use(Print);
Vue.prototype.getViewportSize = function() {
  return {
    width:
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth,
    height:
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight
  };
};

Vue.use(ElementUI);
Vue.use(Print); //注册
Vue.prototype.$message = message;
Vue.prototype.$count = count;
Vue.prototype.api = api;
Vue.prototype.$qs = qs;
Vue.prototype.$axios = axios;
Vue.prototype.$Util = Util.Util;

Vue.config.productionTip = false;
filters(Vue);

//  获取角色信息，根据用户权限动态加载路由

import elDragDialog from "./el-dragDialog/index";
Vue.use(elDragDialog);
/**/
import {delStorage, getStorage} from './assets/js/storage'
function getTree(to,from,next){
  if (store.getters.token && store.getters.token !== "undefined") {
    // store.dispatch("setToken", store.getters.token);
    if (to.path === "/login" || to.path === "/printReimburse" || to.path === "/flowmeterPrint" || to.path === "/fillingVolumePrint" || to.path === "/loadingAndUnloadingPrint" || to.path === "/specsPrint" || to.path === "/weightPrint"
      || to.path === "/settlementflowmeterPrint"|| to.path === "/settlementfillingVolumePrint"|| to.path === "/settlementloadingAndUnloadingPrint"|| to.path === "/settlementspecsPrint"|| to.path === "/settlementweightPrint"|| to.path === "/transportPrint") {
      next();
    } else {
      // if (store.state.accountId == null) {
      //   store.dispatch("setToken", "");
      //   store.dispatch("setUserName", "");
      //   store.dispatch("setRoleName", "");
      //   store.dispatch("setCompanyShortName", "");
      //   store.dispatch("setStaffName", "");
      //   this.$router.push("/login");
      //   return;
      // }
      if (!store.getters.info) {
        !(async function getAddRouters() {
          axios
            .get("/deyt/base/menu/res/tree")
            .then(async function(response) {
              if (response.data.status == 500) {
                message.error('加载数据失败，请尽快联系管理员！!！')
                return
              }
              let temps = new Array();
              temps.push(response.data.data.btnList);
              localStorage.setItem("btnKeys", temps);
              await store.dispatch("getInfo", response.data);
              var obj = sessionStorage.getItem("tabnavBox");
              if (obj) {
                await store.dispatch("alltabnavBox", eval("(" + obj + ")"));
              }
              store
                .dispatch("initRoutes", store.getters.info.authorityRouter)
                .then(() => {
                  router.addRoutes(store.getters.addRouters);
                  next({ ...to, replace: true });
                });
            })
            .catch(function(error) {
              console.log(error);
            });
        })();
      } else {
        let is404 = to.matched.some(record => {
          if (record.meta.role) {
            return store.getters.info.authorityRouter === -1;
          }
        });
        if (is404) {
          next({ path: "/404" });
          return false;
        }
        next();
      }
    }
  } else {
    if (to.path === "/login") {
      next();
    } else {
      next({ path: "/login" });
    }
  }
}
router.beforeEach((to, from, next) => {
  if(to.query.isLink){//从别的系统跳过来
    localStorage.clear();
    //获取跨域storage
    getStorage().then(res=>{
      if(res){
        localStorage.setItem('token',res.access_token);
        localStorage.setItem('departName',res.departName);
        store.dispatch("setToken", res.access_token);
        store.dispatch("setCompanyShortName", res.companyShortName);
        store.dispatch("setRoleName", res.roleName);
        store.dispatch("setStaffName", res.staffName);
        store.dispatch("setStaffName", res.staffName);
        store.dispatch("setAccountId", res.accountId);
        getTree(to,from,next)
      }
    }).catch(err=>{
      getTree(to,from,next);
      console.log(err);
    });
  }else{
    getTree(to,from,next);
  }
});

/* eslint-disable no-new */
export const vue = new Vue({
  el: "#app",
  router,
  store,
  i18n,
  render: h => h(App),
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js